import { Box, TextField } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import CarbonCreditingProgrammeSelect from "./CarbonCreditingProgrammeSelect";
import { useFormikContext } from "formik";
import { ReactNode } from "react";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

export type ProgrammeInfoContainerProps = {
  assetTypeField: ReactNode;
};

function ProgrammeInfoContainer({
  assetTypeField,
}: ProgrammeInfoContainerProps) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <Box data-testid="programme-info-section-collapsible">
      <SectionCollapsible label="Programme Info">
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          {assetTypeField}
        </Box>
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          <CarbonCreditingProgrammeSelect />
        </Box>
        <TextField
          id="solution-programme-info-carbon-accounting-methodology"
          label="Carbon Accounting Methodology"
          variant="standard"
          fullWidth
          sx={{ paddingBottom: 2 }}
          autoComplete="disabled"
          onChange={(event) =>
            context.setFieldValue(
              "programme-info.carbon-accounting-methodology",
              (event.target as HTMLInputElement).value,
            )
          }
          value={
            context.values["programme-info"]["carbon-accounting-methodology"]
          }
        />
        <TextField
          id="solution-programme-info-description-document"
          label="Project Description Document Link"
          variant="standard"
          fullWidth
          autoComplete="disabled"
          onChange={(event) =>
            context.setFieldValue(
              "programme-info.description-document",
              (event.target as HTMLInputElement).value,
            )
          }
          value={context.values["programme-info"]["description-document"]}
          error={Boolean(
            context.errors["programme-info"]?.["description-document"],
          )}
          helperText={
            context.errors["programme-info"]?.["description-document"]
          }
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ProgrammeInfoContainer;
